import posthog from 'posthog-js';

const KEY = process.env.BUN_PUBLIC_POSTHOG_KEY;
const HOST = process.env.BUN_PUBLIC_POSTHOG_HOST;
const isEnabled = Boolean(KEY) && process.env.BUN_PUBLIC_DEV_AUTH !== '1';

export function initPostHog() {
  if (!isEnabled || !KEY) return;

  posthog.init(KEY, {
    api_host: HOST ?? 'https://us.i.posthog.com',
    capture_pageview: false,
  });
}

export function capturePageView() {
  if (!isEnabled) return;

  posthog.capture('$pageview', { $current_url: window.location.href });
}

export function identifyUser(id: string, properties: Record<string, unknown>) {
  if (!isEnabled) return;

  posthog.identify(id, properties);
}
